import { Stack, Typography } from "@mui/material";
import Iconify from "../../../../components/iconify";
import PropTypes from "prop-types";
import { checkOpeningHours } from "src/utils/dateUtils";
import { useLocales } from "src/locales";

const RatingShowcaseSummaryDetails = ({ general, rating, address }) => {
  const isOpen = general.openingHours?.length ? checkOpeningHours(general.openingHours) : false;
  const { translate } = useLocales();
  return (
    <>
      <Stack direction="row" alignItems={"center"}>
        <Typography align="center" lineHeight={0.8} fontSize={24}>
          4.2
        </Typography>
        <Iconify icon="material-symbols:star" width={24} />
      </Stack>
      <Stack
        direction="column"
        sx={{ borderLeft: "2px solid white", paddingLeft: 1 }}
      >
        <Typography
          variant="h6"
          align="left"
          lineHeight={0.8}
          onClick={() => {
            window.open(address.googleLocationLink);
          }}
        >
          {address.street && address.street.toUpperCase()}
        </Typography>
        {general.openingHours?.length ? (
          <Typography marginTop={1} align="left" fontSize={20} lineHeight={1}>
            {isOpen ? translate("productPage.openNow") : translate("productPage.closedNow")}
          </Typography>
        ) : null}
        {rating.program && !general.openingHours?.length && (
          <Typography marginTop={1} align="left" fontSize={20} lineHeight={1}>
            {rating.program.toUpperCase()}
          </Typography>
        )}
      </Stack>
    </>
  );
};

RatingShowcaseSummaryDetails.propTypes = {
  general: PropTypes.object,
  rating: PropTypes.object,
  address: PropTypes.object,
};

export default RatingShowcaseSummaryDetails;
